import { callApi } from "@src/api/callApi"
import { POST_TOKEN_RESPONSE } from "./postToken"

export const getUsersConfirmationToken = (token: string) =>
  callApi<null, POST_TOKEN_RESPONSE>({
    method: "GET",
    path: "/users/confirmation?confirmation_token=" + token,
  })
